export default __webpack_public_path__ + "static/media/linkedin.55c475ef.png";